import uuidv1 from 'uuid/v1';

export default class DemoService {
  constructor(logger, dao, store) {
    this.logger = logger;
    this.dao = dao;
    this.store = store;
  }

  // async initializeDemo(height, weight) {
  //   const result = await this.auth.authenticate();
  //   const member = await this.createMember(
  //     height,
  //     weight,
  //     result.tokens.identity_id.split(':').pop(),
  //   );
  //   if (!member) {
  //     throw new Error('There was a problem completing the demo. Please try again later.');
  //   }
  // }

  async createMember(height, weight, cognitoId) {
    let member;
    try {
      member = await this.dao.addMember({
        member_id: uuidv1(),
        access_level: 5,
        height,
        weight,
        aws_cognito_sub: cognitoId,
      });

      const data = {
        memberId: member.data.member_id,
        height: member.data.height,
        weight: member.data.weight,
        accessLevel: member.data.access_level,
        memberType: 'Athlete',
        cognitoUsername: cognitoId,
      };
      this.store.dispatch('setUserProperties', data);

      return member.data;
    } catch (e) {
      this.logger.capture(e);
      return false;
    }
  }
}
